import styled from 'styled-components'
import { font, colors, spacing } from '@chegg-ui/theme'

export const MainContainer = styled.div`
  width: 100vw;
  height: 100vh;
`

export const AdContainer = styled.div`
  width: calc(100vw - 400px);
  overflow: auto;
`

export const CopySuccessContainer = styled.div`
  width: 400px;
`

export const CloseBar = styled.div`
  height: 54px;
  width: 100vw;
  background: #242035e5 90%;
  font-size: ${font.size.px22};
  color: ${colors.white};
  font-weight: 700;
  text-align: end;
  padding-top: ${spacing.px16};
  padding-right: ${spacing.px48};
`

export const AdAndCopyContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 54px);
`
